export class nuevousuariodto{
  rol : any;
	usuario : any;
	tipodocumento : any;
	numerodocumento : any;
	nombres : any;
	apellidos : any;
	correo : any;
	telefono : any;
	extencion : any;
	cargo : any;
  fuente : any;
}
